import { styled } from "stitches.config";

export const TodoList = styled("div", {
  backgroundColor: "#ffffff",
  boxShadow: "0px 0px 17px rgba(0, 0, 0, 0.04)",
  borderRadius: "10px",
  padding: "20px 24px",
});
